export function isMacPlatform(platform?: string): boolean {
  const detectedPlatform = platform ?? (typeof navigator === 'undefined' ? '' : navigator.platform);
  return /mac/i.test(detectedPlatform);
}

export function getShortcutLabels(platform?: string) {
  const isMac = isMacPlatform(platform);
  const primary = isMac ? '⌘' : 'Ctrl';
  const alternate = isMac ? '⌥' : 'Alt';

  return {
    mic: `Микрофон (${primary} + D)`,
    camera: `Камера (${primary} + E)`,
    raiseHand: `Поднять или опустить руку (${primary} + Shift + Y)`,
    chat: `Чат (${primary} + ${alternate} + C)`,
    screenShare: `Демонстрация экрана (${primary} + Shift + S)`,
    leave: `Выйти из встречи (${primary} + Shift + H)`,
  };
}
